import React, { useRef, useState } from 'react'
import { DietryRequirementFormData } from './AdditionalQuestions/AdditionalQuestionsForm.Data'
import FormCreator from '../../../../../components/forms/FormCreator';
import { useContext } from 'react';
import BasicDetailContext from '../../../utils/BasicDetailContext';
import TitleWrapper from '../../../../../components/ui/titlewrapper/TitleWrapper';

const DietaryRequirementForm = () => {
    const dietaryRequirementRef = useRef();
    const { isDietry, setIsDietry } = useContext(BasicDetailContext);

    const onColumnChange = (dataFieldName, updateFormData) => {
        if (dataFieldName === "isDietaryRequirements")
            updateFormData?.isDietaryRequirements === 'no' ? setIsDietry(false) : setIsDietry(true)
    }
    return (
        <div className="row">
            <FormCreator
                config={DietryRequirementFormData}
                ref={dietaryRequirementRef}
                key={false}
                onColumnChange={onColumnChange}
            />
            {isDietry && <div>
                <TitleWrapper title="Dietary Requirement" >
                    <ul>
                        <li>None</li>
                        <li>Halal</li>
                        <li>Vegetarian or Vegan</li>
                        <li>Pescetarian</li>
                        <li>No Beef</li>
                    </ul>
                </TitleWrapper>
            </div>
            }
        </div>
    )
}

export default DietaryRequirementForm
